import React from 'react';
import { InputNumber } from '@components/framework/input/InputNumber';
import CurrencyDropdown from '@components/ringil3/Input/InputPriceWithCurrency/CurrencyDropdown.tsx';

interface ComponentProps {
  value: UIPriceWithCurrency;
  onChange: (value: UIPriceWithCurrency) => void;
  disabled?: boolean;
  dataTestId?: string;
  dataTestIdCurrency?: string;
}

export interface UIPriceWithCurrency {
  amount: number;
  currencyCode: string;
}
// OBSOLETE
const InputPricePlain: React.FC<ComponentProps> = ({ value, onChange, disabled = false, dataTestId, dataTestIdCurrency }) => {
  const changeAmount = (amount: number) => {
    onChange({ ...value, amount: amount });
  };
  const changeCurrency = (currencyCode: string) => {
    onChange({ ...value, currencyCode: currencyCode });
  };

  return (
    <>
      <div data-testid={dataTestId}>
        <InputNumber value={value?.amount} onChange={e => changeAmount(e.value)} minFractionDigits={2} maxFractionDigits={2} locale={'cs'} disabled={disabled} />
      </div>
      <CurrencyDropdown selectedCurrency={value?.currencyCode} onSelected={v => changeCurrency(v)} required={false} disabled={disabled} dataTestId={dataTestIdCurrency} />
    </>
  );
};

export default InputPricePlain;
